import { RawQueryStringParameters, Response, Result } from "./types"

import paths from "../../paths"
import { service } from "../../Service"

export async function get(params?: RawQueryStringParameters) {
  try {
    const queryParams = new URLSearchParams(params).toString()
    const url = `${paths.geolocation()}?${queryParams}`
    const response = await service.get<Response>(url)

    return transformResponse(response.body)
  } catch (error) {
    throw new Error(`API Geolocation did not respond correctly`)
  }
}

function transformResponse(response: Response): Result {
  const states = response.objects.states.map(state => ({
    name: state.name,
    stateId: state.state_id,
  }))

  const cities = response.objects.cities.map(city => ({
    name: city.name,
  }))

  return {
    objects: {
      states,
      cities,
    },
  }
}
